import {resolveBackground} from '#core/utils/color-utils.js';

import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

export function foreignWindowFactory(PALETTE) {
    const {FONT} = PALETTE;

    return {
        ForeignWindowView: {
            header: {
                container: {
                    ...resolveBackground(PALETTE.FOREIGN_WINDOW_BG),
                    height: '48px',
                },
                closeButton: generateCloseButton(PALETTE.FOREIGN_WINDOW_CLOSE_BUTTON, CLOSE_BUTTON_TYPES.COMMON),
                titleText: {
                    fontSize: FONT.SIZE_XLARGE,
                    textTransform: 'uppercase',
                    ...PALETTE.FOREIGN_WINDOW_HEADER_TEXT,
                },
            },
        },
    };
}
